module.exports = __webpack_public_path__ + "img/NeilQuateman.9ee9cdf5.jpg";